import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Box } from '@mui/material';
import type { ReactNode } from 'react';
import { GLYPHS } from './glyphs';

export interface AppDialogProps {
  open: boolean;
  title: string;
  onClose: () => void;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg';
  children: ReactNode;
  actions?: ReactNode;
}

/** 표준 모달 셸 — 제목 + × 닫기. 아이콘 금지 원칙의 다이얼로그 기준 구현 */
export function AppDialog({ open, title, onClose, maxWidth = 'sm', children, actions }: AppDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pr: 'var(--space-3)' }}>
        <Box component="span" sx={{ fontSize: 'var(--size-md)', fontWeight: 700 }}>{title}</Box>
        <IconButton aria-label="닫기" onClick={onClose}
          sx={{ fontSize: 22, lineHeight: 1, color: 'var(--fg-secondary)' }}>
          {GLYPHS.close}
        </IconButton>
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
      {actions && <DialogActions sx={{ p: 'var(--space-4)' }}>{actions}</DialogActions>}
    </Dialog>
  );
}
